import {
  jb_date_css_default
} from "./chunk.V4QXQQY3.js";
import {
  reset_css_default
} from "./chunk.YAATWOBE.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  A,
  b,
  i
} from "./chunk.BPIW577J.js";
import {
  n
} from "./chunk.XW2RSTES.js";
import {
  __decorateClass
} from "./chunk.LUIRGYUH.js";

// src/components/jb-date/jb-date.ts
var JbDate = class extends i {
  render() {
    return b`<time part="time"
      ><span>${this.date}</span>${this.time ? b` <span>${this.time}</span>` : A}</time
    >`;
  }
};
JbDate.styles = [reset_css_default, jb_date_css_default];
__decorateClass([
  n()
], JbDate.prototype, "date", 2);
__decorateClass([
  n()
], JbDate.prototype, "time", 2);
JbDate = __decorateClass([
  customElement("jb-date")
], JbDate);

export {
  JbDate
};
